import SubLayout from "@/components/SubLayout";
import { useEffect, useMemo } from "react";
import styles from "./index.module.scss";
import { useLogic } from "./logic";

import { CustomerIcon } from "@/components/CustomerIcon";
import { FilterLayout } from "@/components/FilterLayout";
import { MessageIcon } from "@/components/MessageIcon";
// import { AmountOrder } from './components/AmountOrder';
// import { DateRangePicker } from '@/components/DateRangePicker';
import { AhooksInfiniteScrollFrame } from "@/components/AhooksInfiniteScrollFrame";
import { PendingOrder } from "@/types/Api/Market/PendingOrder/myPendingOrderDetail";
import { PullToRefresh, SafeArea, Space } from "antd-mobile";
import { useNavigate } from "react-router-dom";
import { ListItem } from "./components/ListItem";
import {
  PENDING_FILTERS,
  formatFiltersToParams,
  parseParamsToFilters,
} from "./utils";
import { ErType } from "@/constants/order/key";

export function PageMyPendingOrders() {
  const logic = useLogic();

  const navigate = useNavigate();
  const filters = useMemo(() => {
    const _filters = parseParamsToFilters(logic.params);
    return _filters;
  }, [logic.params]);

  const onSubmit = (filters: Record<string, string[]>) => {
    const params = formatFiltersToParams(filters);
    onSearch({
      ...params,
      page: 1,
    });
  };
  const onSearch = (newParams: any) => {
    logic.paramsRef.current = { ...logic.paramsRef.current, ...newParams };
    logic.infiniteList.reload();
  };
  useEffect(() => {
    logic.infiniteList.reload();
  }, []);

  const itemClick = (order: PendingOrder) => {
    navigate(`/selling/${order.pendingOrderId}?m=${order.sellerType ===ErType.Business ?1:0}`);
  };

  return (
    <SubLayout
      title={"我的挂单"}
      header={{
        extra: (
          <Space>
            <MessageIcon />
            <CustomerIcon />
          </Space>
        ),
      }}
    >
      <div className={styles.page} ref={logic.scollableRef}>
        <section className={styles.filter}>
          <div className={styles.header}>
            <div className={styles.headerItem}>时间</div>
            <div className={styles.headerItem}>收款方式</div>
            <div className={styles.headerItem}>金额</div>
            <div className={styles.headerItem}>状态</div>
          </div>
          <FilterLayout
            items={PENDING_FILTERS}
            filters={filters}
            onChange={onSubmit}
          >
            <>
              <span>排序方式 </span>
              {/* <AmountOrder order={order} onChange={setOrder}/>
                      <DateRangePicker value={dateRange} onChange={setDateRange}/> */}
            </>
          </FilterLayout>
        </section>
        <section className={styles.content}>
          <PullToRefresh onRefresh={() => logic.infiniteList.reloadAsync()}>
            <AhooksInfiniteScrollFrame {...logic.infiniteList}>
              {logic.infiniteList.data?.list.map((item) => {
                return (
                  <ListItem
                    item={item}
                    key={item.pendingOrderId}
                    onClick={() => itemClick(item)}
                  />
                );
              })}
            </AhooksInfiniteScrollFrame>
          </PullToRefresh>
          <SafeArea position="bottom" />
        </section>
      </div>
    </SubLayout>
  );
}
